interface IModalState {
  isCartModalVisible: boolean
  isMultiplePaymentModalVisible: boolean
  isProductVisualizerModalVisible: boolean
  isSizeGuideModalVisible: boolean
  isBrandVoucherModalVisible: boolean
  isPromoPriceModalVisible: boolean
  isProductAvailabilityModalVisible: boolean
  isReviewRulesVisible: boolean
  displayOverlay: boolean
}

const MODAL_OPEN = 'open';
const MODAL_CLOSE = 'close';
const MODAL_CART = 'cart';
const MODAL_SIZE_GUIDE = 'size_guide';
const MODAL_MULTIPLE_PAYMENT = 'multiple_payment';
const MODAL_PRODUCT_VISUALIZER = 'product_visualizer';
const MODAL_BRAND_VOUCHER = 'brand_voucher';
const MODAL_PROMO_PRICE = 'promo_price';
const MODAL_PRODUCT_AVAILABILITY = 'product_availability';
const MODAL_REVIEW_RULES = 'review_rules';

export const useModalStore = defineStore({
  id: 'modal',
  state: (): IModalState => ({
    isCartModalVisible: false,
    isMultiplePaymentModalVisible: false,
    isProductVisualizerModalVisible: false,
    isSizeGuideModalVisible: false,
    isBrandVoucherModalVisible: false,
    isProductAvailabilityModalVisible: false,
    isPromoPriceModalVisible: false,
    isReviewRulesVisible: false,
    displayOverlay: false,
  }),
  getters: {
  },
  actions: {
    displayModal(name: string, action: string) {
      switch (name) {
        case MODAL_CART:
          if (action === MODAL_OPEN) return this.isCartModalVisible = true;
          if (action === MODAL_CLOSE) return this.isCartModalVisible = false
          break;
        case MODAL_MULTIPLE_PAYMENT:
          if (action === MODAL_OPEN) return this.isMultiplePaymentModalVisible = true;
          if (action === MODAL_CLOSE) return this.isMultiplePaymentModalVisible = false;
          break;
        case MODAL_SIZE_GUIDE:
          if (action === MODAL_OPEN) return this.isSizeGuideModalVisible = true;
          if (action === MODAL_CLOSE) return this.isSizeGuideModalVisible = false;
          break;
        case MODAL_PRODUCT_VISUALIZER:
          if (action === MODAL_OPEN) return this.isProductVisualizerModalVisible = true;
          if (action === MODAL_CLOSE) return this.isProductVisualizerModalVisible = false;
          break;
        case MODAL_BRAND_VOUCHER:
          if (action === MODAL_OPEN) return this.isBrandVoucherModalVisible = true;
          if (action === MODAL_CLOSE) return this.isBrandVoucherModalVisible = false;
          break;
        case MODAL_PROMO_PRICE:
          if (action === MODAL_OPEN) return this.isPromoPriceModalVisible = true;
          if (action === MODAL_CLOSE) return this.isPromoPriceModalVisible = false;
          break;
        case MODAL_PRODUCT_AVAILABILITY:
          if (action === MODAL_OPEN) return this.isProductAvailabilityModalVisible = true;
          if (action === MODAL_CLOSE) return this.isProductAvailabilityModalVisible = false;
          break;
        case MODAL_REVIEW_RULES:
          if (action === MODAL_OPEN) return this.isReviewRulesVisible = true;
          if (action === MODAL_CLOSE) return this.isReviewRulesVisible = false;
          break;
        default:
          break;
      }
    },
  },
});

export {
  MODAL_OPEN,
  MODAL_CLOSE,
  MODAL_CART,
  MODAL_BRAND_VOUCHER,
  MODAL_SIZE_GUIDE,
  MODAL_MULTIPLE_PAYMENT,
  MODAL_PRODUCT_VISUALIZER,
  MODAL_PROMO_PRICE,
  MODAL_PRODUCT_AVAILABILITY,
  MODAL_REVIEW_RULES
}
